import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import {
  CanonicalUser,
  MoodleDashboardService,
  UserCourseRow,
} from '../../../services/moodle-dashboard.service';
import { participantPseudonym } from '../../../helpers/participant-pseudonym';

@Component({
  selector: 'app-moodle-dashboard-user-detail',
  templateUrl: './user-detail.component.html',
  styleUrl: './detail-dialogs.scss',
})
export class MoodleDashboardUserDetailComponent implements OnInit {
  @Input() user!: CanonicalUser;
  loading = true;
  rows: UserCourseRow[] = [];

  constructor(
    private moodleDashboard: MoodleDashboardService,
    public ref: NbDialogRef<MoodleDashboardUserDetailComponent>,
  ) {}

  ngOnInit(): void {
    this.moodleDashboard.listUserEnrollments(this.user.id).subscribe({
      next: (rows) => {
        this.rows = rows;
        this.loading = false;
      },
      error: () => (this.loading = false),
    });
  }

  userName(): string {
    return participantPseudonym({
      id: this.user.id,
      learner_user_id: this.user.learner_id,
      external_user_id: String(this.user.moodle_user_id),
      first_name: this.user.first_name,
      last_name: this.user.last_name,
      email: this.user.email,
    });
  }

  totalGrades(row: UserCourseRow): number {
    return row.grades?.length || 0;
  }

  trackRow = (_: number, r: UserCourseRow) => r.enrollment_id;
}
